import React from 'react';
import '../less/esg.less';
import banner_img from '../img/esg/banner_img.webp';
import DOMPurify from 'utils/sanitize';
import cob_img from '../img/esg/cob_img.webp';
import TextBlock from '../../../auxiliary-components/shared/TextBlock';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import InfoBlock from '../../../auxiliary-components/shared/InfoBlock';
import priorities from '../enums/esg/priorities.json';
import { getSafeLinkProps } from '../../../helpers/utils/urlSecurity';
import bottomBlocks from '../enums/esg/bottomBlocks.json';
import BusinessOrder from '../../BusinessOrder';
import charity_img from '../img/esg/charity_img.webp';
import inclusion_img from '../img/esg/inclusion_img.webp';
import our_people_img from '../img/esg/our_people_img.webp';

export default function template() {
    const tabs = [
        {tab: 'environmental', title: 'ABOUT_ESG_TABS_TITLE_01'},
        {tab: 'social', title: 'ABOUT_ESG_TABS_TITLE_02'},
        {tab: 'governance', title: 'ABOUT_ESG_TABS_TITLE_03'}
    ];

    const renderInfoSection = (titleKey, textKey, img, alt) => (
        <div className="info-section">
            <div className="container">
                <div className="info-section__body">
                    <img className="info-section__image" src={img} alt={alt ? this.l10n(alt) : ''} {...(!alt && {'aria-hidden': 'true'})} />
                    <div className="info-section__left">
                        <h3 className="info-section__title">{this.l10n(titleKey)}</h3>
                        <div className="info-section__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(textKey))}}></div>
                    </div>
                </div>
            </div>
        </div>
    );

    const handlerMap = {
        toggleModal: () => this.toggleModal()
    };

    return (
        <div className="module-about-esg esg-about">
            <div>
              <div className="esg-about__banner banner-esg">
                <div className="container">
                  <div className="banner-esg__body">
                    <img className="banner-esg__image" src={banner_img} alt="" aria-hidden="true" />
                    <div className="banner-esg__left">
                      <h1 className="banner-esg__title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('ABOUT_ESG_BANNER_TITLE'))}}></h1>
                      <p className="banner-esg__text">{this.l10n('ABOUT_ESG_BANNER_TEXT')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <TextBlock text="ABOUT_ESG_TEXT" />
              <section className="cob-appeal" aria-labelledby="esg-cob-appeal-title">
                <div className="container">
                  <div className="cob-appeal__body">
                    <img className="cob-appeal__image" src={cob_img} alt={this.l10n('ABOUT_ESG_COB_APPEAL_IMG_ALT')} />
                    <div className="cob-appeal__right">
                      <h2 id="esg-cob-appeal-title" className="cob-appeal__title">{this.l10n('ABOUT_ESG_COB_APPEAL_TITLE')}</h2>
                      <blockquote className="cob-appeal__text">
                        <p><strong>{this.l10n('ABOUT_ESG_COB_APPEAL_TEXT_01')}</strong></p>
                        <p>{this.l10n('ABOUT_ESG_COB_APPEAL_TEXT_02')}</p>
                        <p>{this.l10n('ABOUT_ESG_COB_APPEAL_TEXT_03')}</p>
                        <p>{this.l10n('ABOUT_ESG_COB_APPEAL_TEXT_04')}</p>
                        <p>{this.l10n('ABOUT_ESG_COB_APPEAL_TEXT_05')}</p>
                        <p>{this.l10n('ABOUT_ESG_COB_APPEAL_TEXT_06')}</p>
                        <p>{this.l10n('ABOUT_ESG_COB_APPEAL_TEXT_07')}</p>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <section className="progress-meaning" aria-labelledby="esg-progress-meaning-title">
              <div className="progress-meaning__top">
                <div className="container">
                  <h2 id="esg-progress-meaning-title" className="progress-meaning__title">{this.l10n('ABOUT_ESG_PROGRESS_MEANING_TITLE')}</h2>
                  <div className="progress-meaning__text">
                    <p>{this.l10n('ABOUT_ESG_PROGRESS_MEANING_TEXT_01')}</p>
                    <p>{this.l10n('ABOUT_ESG_PROGRESS_MEANING_TEXT_02')}</p>
                    <p><strong>{this.l10n('ABOUT_ESG_PROGRESS_MEANING_TEXT_03')}</strong></p>
                  </div>
                </div>
                <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
                  <InfoBlock text="ABOUT_ESG_PROGRESS_MEANING_INFO_BLOCK_TEXT_01"/>
                  <InfoBlock text="ABOUT_ESG_PROGRESS_MEANING_INFO_BLOCK_TEXT_02"/>
                  <InfoBlock text="ABOUT_ESG_PROGRESS_MEANING_INFO_BLOCK_TEXT_03"/>
                </Tabs>
              </div>
            </section>
            <section className="priorities" aria-labelledby="esg-priorities-title">
              <div className="container">
                <h2 id="esg-priorities-title" className="priorities__title">{this.l10n('ABOUT_ESG_PRIORITIES_TITLE')}</h2>
                <p className="priorities__text">{this.l10n('ABOUT_ESG_PRIORITIES_TEXT')}</p>
                <ul className="priorities__body">
                  {priorities.map((item) => (
                    <li className="priorities__item item-priorities" key={item.id}>
                      <h3 className="item-priorities__title">{this.l10n(item.title)}</h3>
                      <p className="item-priorities__text">{this.l10n(item.text)}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
            <section className="in-action" aria-labelledby="esg-in-action-title">
              <div className="container">
                <h2 id="esg-in-action-title" className="in-action__title">{this.l10n('ABOUT_ESG_IN_ACTION_TITLE')}</h2>
                <p className="in-action__text">{this.l10n('ABOUT_ESG_IN_ACTION_TEXT')}</p>
              </div>
              {renderInfoSection('ABOUT_ESG_INFO_SECTION_TITLE_01', 'ABOUT_ESG_INFO_SECTION_TEXT_01', charity_img, 'ABOUT_ESG_INFO_SECTION_ALT_01')}
              <InfoBlock text="ABOUT_ESG_IN_ACTION_INFO_BLOCK_TEXT"/>
              {renderInfoSection('ABOUT_ESG_INFO_SECTION_TITLE_02', 'ABOUT_ESG_INFO_SECTION_TEXT_02', inclusion_img, 'ABOUT_ESG_INFO_SECTION_ALT_02')}
            </section>
            <section className="corporate-governance" aria-labelledby="esg-corp-gov-title">
              <div className="container">
                <h2 id="esg-corp-gov-title" className="corporate-governance__title">{this.l10n('ABOUT_ESG_CORPORATE_GOVERNANCE_TITLE')}</h2>
                <div className="corporate-governance__text">
                  <p>{this.l10n('ABOUT_ESG_CORPORATE_GOVERNANCE_TEXT_01')}</p>
                  <p>{this.l10n('ABOUT_ESG_CORPORATE_GOVERNANCE_TEXT_02')}</p>
                </div>
              </div>
              {renderInfoSection('ABOUT_ESG_INFO_SECTION_TITLE_03', 'ABOUT_ESG_INFO_SECTION_TEXT_03', our_people_img, 'ABOUT_ESG_INFO_SECTION_ALT_03')}
            </section>
            {bottomBlocks.map((item) => (
              <section className="esg-about__bottom bottom-block" key={item.id} aria-labelledby={`esg-bottom-title-${item.id}`}>
                <div className="container">
                  <div className="bottom-block__body">
                    <h2 id={`esg-bottom-title-${item.id}`} className="bottom-block__title">{this.l10n(item.title)}</h2>
                    <div className="bottom-block__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(item.text))}}/>
                    {handlerMap[item.link]
                        ? <button type="button" className="bottom-block__btn" onClick={handlerMap[item.link]}>{this.l10n(item.btnText)}</button>
                        : <a className="bottom-block__btn" {...getSafeLinkProps(item.link, {navigate: this.navigate})}>{this.l10n(item.btnText)}</a>
                    }
                  </div>
                </div>
              </section>
            ))}
            {this.state.showModal && <BusinessOrder attribute="esg" closeModal={() => this.toggleModal()} />}
        </div>
    );
}
